<button class="google-signin-btn">
	<div class="icon-wrapper">
		<img
			src="/assets/images/icons/google-logo.svg"
			alt="Google logo"
			class="icon"
		/>
	</div>
	<div class="text">Inscrever-se com o Google</div>
</button>
